<script lang="ts">
    import {datatypes, type Datatype} from 'src/typings';
    import type {ScalarGridValue} from 'src/features/record-grid/lib/types';
    import type {ValueFormatResponse} from 'src/features/record/field-types/types';
    import DateRangeValue from './datatypeValue/DateRangeValue.svelte';
    import NumericValue from './datatypeValue/NumericValue.svelte';
    import TextValue from './datatypeValue/TextValue.svelte';

    export let value: ScalarGridValue;
    export let valueFormat: ValueFormatResponse | null = null;
    export let datatype: Datatype;

    function isDatatype(...datatypeNames: string[]): boolean {
        return datatypeNames.includes(datatype.name);
    }

    const numericDatatypeScales: Record<string, number> = {
        NUMBER: 0,
        NUMBER_DECIMAL_2: 2,
        NUMBER_DECIMAL_4: 4,
        NUMBER_DECIMAL_6: 6
    };

    function getNumericScale(): number {
        return numericDatatypeScales[datatype.name] ?? 0;
    }
</script>

{#if isDatatype(datatypes.NUMBER, datatypes.NUMBER_DECIMAL_2, datatypes.NUMBER_DECIMAL_4, datatypes.NUMBER_DECIMAL_6) && typeof value.value === 'number'}
    <NumericValue value={value.value} {valueFormat} scale={getNumericScale()}/>
{:else if isDatatype(datatypes.DATETIME_RANGE) && typeof value.value === 'string'}
    <DateRangeValue value={value.value}/>
{:else if isDatatype(datatypes.TEXT)}
    <TextValue {value} {valueFormat}/>
{:else}
    <!-- Default display -->
    <span>
        {value.text}
    </span>
{/if}